import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { typographies } from "../../../../styles/figmaTypographies";
import { StyledFlex } from "../layout";
import { ArrowBackOutlined } from "../../../materialUi/materialUi";
import { Spacer } from "../../Spacer";
import { TextCapitalized } from "../../text/TextCapitalized";

export interface BackButtonProps {
  onClick: () => void;
}

export const BackButton = ({ onClick }: BackButtonProps) => {
  const { t } = useTranslation();

  return (
    <StyledBackButton as="button" type="button" onClick={onClick}>
      <StyledIcon>
        <ArrowBackOutlined />
      </StyledIcon>
      <Spacer x={0.5} />
      <StyledLabel>
        <TextCapitalized>{t("backButton.label")}</TextCapitalized>
      </StyledLabel>
    </StyledBackButton>
  );
};

const StyledBackButton = styled(StyledFlex)`
  /* Reset the native button chrome so spacing comes only from Spacer. */
  all: unset;
  /* all: unset also drops the display inherited from StyledFlex. */
  display: flex;
  align-items: center;
  cursor: pointer;
  color: inherit;
`;

const StyledIcon = styled(StyledFlex)`
  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: currentColor;
  }
`;

const StyledLabel = styled.span`
  ${typographies["Body/M"]}
`;
